import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { Card, CardBody, Text } from '@evertel/web/ui'

import { DnDToolboxItem } from './DnDToolboxItem'
import { LAYOUT_ITEMS, ELEMENT_ITEMS } from './constants'

interface DnDToolboxProps {
    /** Hide the list/subform option when editing a subform (can't nest subforms) */
    hideSubform?: boolean
}

/**
 * Toolbox component containing draggable layout and element items.
 *
 * Layout section: Row, Spacer, Sub Form (special rows)
 * Elements section: Text, Dropdown, Checkbox, Date, Map, User, Media
 */
export const DnDToolbox: React.FC<DnDToolboxProps> = ({
    hideSubform = false
}) => {
    // Filter layout items if we need to hide subform
    const layoutItems = hideSubform
        ? LAYOUT_ITEMS.filter(item => item.layoutType !== 'list')
        : LAYOUT_ITEMS

    return (
        <Card className="sb-toolbox">
            <CardBody>
                {/* Layout Section */}
                <Text
                    tag="div"
                    bold
                    className="sb-toolbox__section-title pb-2"
                >
                    Layout
                </Text>
                {/* <p className="small text-muted mb-2">
                    Drag these onto the form to create rows
                </p> */}
                <SortableContext
                    items={layoutItems.map(i => i.id)}
                    strategy={verticalListSortingStrategy}
                >
                    {layoutItems.map(item => (
                        <DnDToolboxItem
                            key={item.id}
                            id={item.id}
                            type="layout"
                            layoutType={item.layoutType}
                            label={item.label}
                            icon={item.icon}
                        />
                    ))}
                </SortableContext>

                <hr />

                {/* Elements Section */}
                <Text
                    tag="div"
                    bold
                    className="sb-toolbox__section-title pb-2"
                >
                    Form Elements
                </Text>
                {/* <p className="small text-muted mb-2">
                    Drag these into rows (max 3 per row)
                </p> */}
                <SortableContext
                    items={ELEMENT_ITEMS.map(i => i.id)}
                    strategy={verticalListSortingStrategy}
                >
                    {ELEMENT_ITEMS.map(item => (
                        <DnDToolboxItem
                            key={item.id}
                            id={item.id}
                            type="element"
                            elementType={item.elementType}
                            label={item.label}
                            icon={item.icon}
                        />
                    ))}
                </SortableContext>
            </CardBody>
        </Card>
    )
}
